import axios from "axios";

const state = {
    FrscStep:1,
    FrscItems:{},
};

const getters = {
    getFrscStep(state){
        return state.FrscStep
    },
    getFrscItems(state){
        return state.FrscItems
    },
};

const mutations = {
    setFrscStep(state, payload) {
    state.FrscStep = payload;
  },
  setFrscItems(state, payload){
      state.FrscItems=payload
  }
};

const actions = {

    FRSCAppValidationRequest({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/FRSCAppValidationRequest?applicationID=${payload.applicationID}`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setFrscStep", 2);
            commit("setFrscItems", res.data);
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  frscPayment({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/FRSCPaymentRequest?customerID=${payload.customerID}&pin=${payload.pin}&applicationID=${payload.applicationID}&location='WEBSITE'&imei='WEBSITE'`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setBalance",  res.data.updatedMainBalance );
            commit("setCommissionBalance",  res.data.updatedCommissionBalance );
            commit("setFrscStep", 1);
            commit("setFrscItems", {});
            //commit("setSnackbar", true);
            //commit("setServerMessage", res.data.message)
            payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};








